module.exports = __webpack_public_path__ + "img/ch15_01_广场搭讪.691d8500.jpg";